import {
  authApi,
  AuthMethodEnum,
  type CreateSessionRequest,
  CreateSessionRequestEnum,
  type CreateSessionResponse,
} from "@b2bportal/auth-api";
import { axiosInstance } from "@hopper-b2b/api";

export const createSession = async (request: CreateSessionRequest) => {
  try {
    const response =
      await authApi(axiosInstance).apiV0AuthSessionCreatePost(request);
    return response.data;
  } catch (error) {
    console.error("Create session error:", error);
    throw Error("Create session error");
  }
};

export const startSession = (token: string): Promise<CreateSessionResponse> =>
  // eslint-disable-next-line no-async-promise-executor
  new Promise(async (resolve, reject) => {
    const reqBody: CreateSessionRequest = {
      authMethod: {
        token,
        AuthMethod: AuthMethodEnum.PartnerToken,
      },
      CreateSessionRequest: CreateSessionRequestEnum.SignIn,
    };
    try {
      const response = await createSession(reqBody);
      resolve(response);
    } catch (e) {
      reject(e);
    }
  });
export default startSession;
